export default __webpack_public_path__ + "static/media/icon_activity_generator.b8bca4d0.png";